import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import Button from "../../button/Button";
import { Previous } from "../../svg/svgImageList";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";

const elementId = "video-jump-previous-timestamp";

export default observer(function JumpToPreviousTimestamp({
  tooltipTextKey,
}: ComponentWithTooltipProps) {
  const { videoDuration, currentTimestamp, timestamps, jumpPrevious } = videoPlayerService;

  const isJumpPreviousDisabled = useMemo(
    () => videoDuration === 0
      || timestamps?.isEmpty()
      || timestamps?.outOfRange(currentTimestamp)
      || timestamps?.isFirstTimeStamp(currentTimestamp)
    , [currentTimestamp, videoDuration, timestamps]
  );

  if (isJumpPreviousDisabled) return <div className="video-control-item" />;

  return (
    <Tooltip id={elementId} title={tooltipTextKey}>
      <Button
        id={elementId}
        onClick={jumpPrevious}
        disabled={isJumpPreviousDisabled}
        icon={{
          svg: Previous,
          className: "video-control-item jump",
        }}
      />
    </Tooltip>
  );
});
